import type { Patch } from "@freightsimple/shared/types";
import type { LineItem } from "@freightsimple/generated-dashboard-openapi-client/models/LineItem";
import {
  convertToUnit,
  Dimension,
  Units,
} from "@freightsimple/ui-core/Data/Units";

// The dangerous-goods bounds themselves (name lengths, the net-explosive-quantity
// ceiling, the ERAP pattern) are served by the shipment-limits endpoint - the
// backend's ShipmentLimits.DangerousGoods is the single source of truth. Read them
// from useLineItemsShipmentLimits() rather than redeclaring numbers here.

// The explosive mass inside the packages can't exceed the gross weight of the
// item carrying it, so when the item's weight is known it's the tighter cap.
// Before the weight is entered, fall back to the served heaviest-shipment cap.
export function maxDangerousNetExplosiveQuantityKg(
  lineItem: Patch<LineItem>,
  maxNetExplosiveQuantityKg: number,
): number {
  const { weightPerHandlingUnit, numberHandlingUnits } = lineItem;
  if (
    weightPerHandlingUnit === undefined ||
    numberHandlingUnits === undefined
  ) {
    return maxNetExplosiveQuantityKg;
  }
  const totalWeightKg = convertToUnit(
    weightPerHandlingUnit * numberHandlingUnits,
    Units.Metric,
    Dimension.Weight,
  );
  if (totalWeightKg === undefined) {
    return maxNetExplosiveQuantityKg;
  }
  return Math.min(maxNetExplosiveQuantityKg, totalWeightKg);
}

// A count can arrive from a saved draft or commodity without going through the
// field's keystroke check, so the dialog checks the range again before closing.
export function isDangerousNumberPackagesOutOfRange(
  numberPackages: number | undefined,
  maxNumberPackages: number,
): boolean {
  return (
    numberPackages !== undefined &&
    (numberPackages < 1 || numberPackages > maxNumberPackages)
  );
}
